module.exports = __webpack_public_path__ + "img/68.4214847e.jpg";